export const CoverageCodes = {
  MC: 'MC',
};
